// extracted by mini-css-extract-plugin
export default {"loading":"LoadingSpinner_loading__wAGbq"};